(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name trainingPrograms.service:TrainingAssignCrewLogic
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .service('TrainingAssignCrewLogic', TrainingAssignCrewLogic);

    function TrainingAssignCrewLogic(TrainingAssignCrewModel, CommonMasterData, MessageService,
                                     RemoteService, applicationConstants, CrewingHelper, CrewingAdaptor, PopupManager) {
        var self = this;

        var lastCrewSearchParam = null;
        var lastTrainingSlotId = null;
        var assignedTraineeDetail = null;


        TrainingAssignCrewModel.assignedTraineeDetail.subscribe(function (trainees) {
            assignedTraineeDetail = trainees;
        });

        /**
         * Load Crew Types and update Model
         */
        self.getCrewTypes = function () {
            CommonMasterData.getCrewTypeList(function (crewTypes) {
                    TrainingAssignCrewModel.setCrewTypes(crewTypes);
                },
                function (error) {
                    MessageService.error(error);
                });
        };

        /**
         * Get Crew List
         * @param params
         */
        self.getCrewList = function (params, isManualSearch) {
            lastCrewSearchParam = params;
            var getCrewListParam = function (formData) {
                var parm = {
                    fromDate: formData.fromDate || null,
                    toDate: formData.toDate || null,
                    crewIds: formData.crewIds && formData.crewIds.length > 0
                      ? formData.crewIds.map(function (c) { return c.crewIds; }) : null,
                    trainerType: (formData.trainerType && formData.trainerType.trainerTypeCode) || null,
                    crewBatchCode: formData.crewBatchType  && formData.crewBatchType.crewBatchCode|| null,
                    crewTypeCode: (formData.crewType && formData.crewType.crewTypeCode) || null,
                    trainingProgramID: (formData.selectedTraining && formData.selectedTraining.trainingProgramID) || null,
                    orderBy: (formData.orderBy && formData.orderBy.code) || null,
                };

                parm.slotId = (formData.selectedTraining && formData.selectedTraining.trainingSlotID) || null;
                return parm;
            };

            if (!!params) {
                var requestParam = getCrewListParam(params);
                RemoteService.getCrewList(requestParam).then(
                    function (response) {
                        if (response.success) {
                            if(response.scheduleCrewData == null && isManualSearch){
                              MessageService.warning(MessageService.MESSAGES.CREWING.TRAINING_EMPTY_SEARCH_RESULT);
                            }
                            TrainingAssignCrewModel.setCrewList(response.scheduleCrewData || []);
                        } else {
                            TrainingAssignCrewModel.setCrewList([]);
                        }
                    },
                    function (error) {
                        MessageService.error();
                        TrainingAssignCrewModel.setCrewList([]);
                    }
                );
            }
        };

        /**
         * Get All Trainer Types
         */
        self.getTrainerTypes = function () {
            RemoteService.getTrainerTypes().then(
                function (response) {
                    TrainingAssignCrewModel.setTrainerTypes(response.trainerTypeList);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

      /**
       * Get Crew Batch Types List
       */
      self.getCrewBatchTypes = function () {
        var param = {
          "description": "",
          "pageSize": -1,
          "startPosition": 1
        };
          RemoteService.loadCrewBatchList(param).then(
            function (response) {
              TrainingAssignCrewModel.setCrewBatchTypes(response.batchList);
            },
            function (error) {
              MessageService.error(error);
            }
          );
      };


      self.onChangeCrewType = function (crewType) {
         self.getCrewIdsByCrewType(crewType);
      };

      /**
       * Get Crew Ids by Crew Types
       */
      self.getCrewIdsByCrewType = function (param) {
        console.log(param);
        var param = {
          crewType: param != null ? param : '',
          active: true,
          crewBase: '',
          fleetExperince: ''
        };

        RemoteService.loadCrewList(param).then(
          function (response) {
            const formattedCrewList = response.crewList.map(function (crew) {
              return {
                crewIdDesc: crew.firstName + ' ' + crew.lastName + ' (' + crew.crewId + ')',
                crewIds: crew.crewId
              };
            });
            self.crewIds = formattedCrewList;
            TrainingAssignCrewModel.setCrewIds(formattedCrewList);
          },
          function (error) {
            MessageService.error(error);
          }
        );
      };

      /**
         * Set Selected Training
         * @param training
         */
        self.setSelectedTraning = function (training) {
            TrainingAssignCrewModel.setSelectedTraining(training);
        };

        /**
         * format traning start date
         * @param training
         * @returns {*}
         */
        self.formatTrainingStartDate = function (training) {
            if (!!training) {
                training.stDayNumber = '';
                training.stDayMonth = '';

                if (!!training.startDate) {
                    training.stDayNumber = moment(training.startDate, applicationConstants.SETTINGS.DATE_FORMAT).format('Do');
                    training.stDayMonth = moment(training.startDate, applicationConstants.SETTINGS.DATE_FORMAT).format('MMMM');
                }
            }
            return training;
        };

        /**
         * Get Training details by slot id
         * @param slotId
         */
        self.getTrainingDetails = function (slotId) {
            if (!!slotId) {
                lastTrainingSlotId = slotId;
                var request = {
                    trainingSlotId: slotId
                };

                var getAssignTrainees = function (response) {
                    var assigned = (response && response.trainingProgramDetail && response.trainingProgramDetail.assignedTraineeDetail ) || []

                    angular.forEach(assigned, function (crew) {
                        crew.allocatedCrewList = [];
                    });


                    if (response && response.trainingProgramDetail && response.trainingProgramDetail.assignedTrainees) {
                        var req;
                        angular.forEach(response.trainingProgramDetail.assignedTrainees, function (crew) {
                            req = _.find(assigned,{crewTypeCode : crew.crewType});
                            if(!!req){
                                req.allocatedCrewList.push(crew)
                            }else{
                                assigned.push({
                                    crewTypeCode :  crew.crewType,
                                    nonRequired : true,
                                    allocatedCrewList : [crew]
                                })
                            }
                        });
                    }

                    return assigned;
                };

                RemoteService.getTrainingBySlotID(request).then(
                    function (response) {
                        TrainingAssignCrewModel.setAssignedTrainerDetail(response && response.trainingProgramDetail && response.trainingProgramDetail.assignedTrainerDetail);
                        TrainingAssignCrewModel.setAssignedTrainers(response && response.trainingProgramDetail && response.trainingProgramDetail.assignedTrainers)

                        TrainingAssignCrewModel.setAssignedTraineeDetail(getAssignTrainees(response));

                        TrainingAssignCrewModel.setTrainingDetails(response && response.trainingProgramDetail);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        };

        /**
         * Unassign Crew From Training
         * @param params
         * @param successFn
         * @param errorFn
         */
        self.unAssignCrew = function (crewProfileId, crewSchdBlockId, slotId) {
            var request = {
                unAssignColl: [{
                    crewProfileId: crewProfileId,
                    crewSchdBlockId: crewSchdBlockId
                }]
            };

            RemoteService.unAssignBlock(request).then(
                function (response) {
                    self.reloadData();
                    MessageService.success(MessageService.MESSAGES.TRAINING_PROGRAME.UNASSIGN_SUCCESS);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.otherHubUnAssignCrew = function (otherHub) {
          MessageService.error("Crew Can be Unassigned from the parent hub ("+otherHub+") only");
        };

        self.getCrewAssignToTrainingFlags = function () {
            return {
                isContinueIllegal: true,
                isUserConfirm: false,
                isExpiryUpdatable: false,
                isIgnoreConflicts: false,
                isIgnoreExpiries: false,
                isIgnoreCrewTypeWarning: false
            };
        };

      self.getCrewAssignToTrainingFlagsForAllSelect = function () {
        return {
          isContinueIllegal: false,
          isUserConfirm: true,
          isExpiryUpdatable: true,
          isIgnoreConflicts: true,
          isIgnoreExpiries: true,
          isIgnoreCrewTypeWarning: true,
          ignoreRequest: true
        };
      };

        self.reloadData = function () {
            if (!!lastTrainingSlotId) {
                self.getTrainingDetails(lastTrainingSlotId);
            }

            if (!!lastCrewSearchParam) {
              self.getCrewList(lastCrewSearchParam);
            }

        };
  self.assignTrainerTrainee = function (assignAs, training, crew, isSelectedAllTrainees) {
            var assignSuccessCallBack = function () {
                self.reloadData();
            };

            var abortAssignment = function () {
                crew.assignAs = '';
            };

          if (assignAs && training && crew) {

              var crewArray = Array.isArray(crew) ? crew : [crew];
              var requestList = [];
              var isSelectAll = isSelectedAllTrainees;

              angular.forEach(crewArray, function (currentCrew) {

                if (angular.isUndefined(training.trainingProgramId) || training.trainingProgramId === null) {
                  abortAssignment();
                  MessageService.warning('Training program is not assigned');
                  return;
                }

                var onCloseCrewTypeConfirmation = function (confirmed) {
                  if (!!confirmed) {
                    performOneAssignment(request, self.getCrewAssignToTrainingFlags());
                  } else {
                    currentCrew.assignAs = '';
                  }
                };

                function onCloseNoneTrainerAssignment(param) {
                  if (!!param) {
                    request.trainerCode = 'TRE';
                    performOneAssignment(request, self.getCrewAssignToTrainingFlags())
                  } else {
                    crew.assignAs = '';
                  }
                }

                var isRequiredCrewType = function (crew) {
                  var flag = false;
                  if (!!assignedTraineeDetail) {
                    var reqCrewTypes = assignedTraineeDetail.map(function (req) {
                      if (!!req.nonRequired) {
                        return '';
                      } else {
                        return req.crewTypeCode;
                      }
                    });

                    if (reqCrewTypes.indexOf(crew.crewTypeCode) >= 0) {
                      flag = true;
                    }
                  }

                  return flag;
                };

                var request = {
                  trainingSlotId: training.trainingSlotId,
                  crewProfileId: currentCrew.crewProfileId,
                  trainingProgramId: training.trainingProgramId,
                  assignDate: training.fromDate,
                  assignTime: training.fromTime,
                  assignAsCrewType: currentCrew.crewTypeCode,
                  trainerCode: assignAs === 'TRAINER' ? (
                    currentCrew.trainerCodes && currentCrew.trainerCodes[0]
                      ? currentCrew.trainerCodes[0].trainerTypeCode
                      : 'TRE'
                  ) : null,
                };

                if(!isSelectAll) {
                  if (assignAs == 'TRAINER') {

                    if (currentCrew.trainerTraineeTypeCategory === 'TRAINER') {
                      currentCrew.trainerCode = currentCrew.trainerCodes[0] && currentCrew.trainerCodes[0].trainerTypeCode || null;
                      performOneAssignment(request, self.getCrewAssignToTrainingFlags())

                    } else {
                      var details = {
                        title: 'Confirmation',
                        messages: ['Selected crew is not a Trainer. Do you wish to Continue?']
                      };
                      PopupManager.openModal('CONFIRM_DIALOG', details, onCloseNoneTrainerAssignment);
                    }
                  } else if (assignAs === 'TRAINEE') {
                    if (!isRequiredCrewType(currentCrew)) {
                      var typeDetails = {
                        title: 'Confirmation',
                        messages: ['Selected crew type is not required for the training. Do you wish to Continue?']
                      };
                      if (!isSelectAll) {
                        PopupManager.openModal('CONFIRM_DIALOG', typeDetails, onCloseCrewTypeConfirmation);
                      }
                    } else {
                      performOneAssignment(request, self.getCrewAssignToTrainingFlags())
                    }
                  }
              } else {
                requestList.push(request);
              }

              });

              // Now call performAssignment once after collecting all requests
              if (isSelectAll && requestList.length > 0) {
                performAssignment(requestList);
              }
            }else{
                MessageService.warning('Training program is not assigned');
                abortAssignment();
            }

      // Perform assignments for one
      function performOneAssignment(request, flags) {
        request.continueIllegal = !!flags.isContinueIllegal;
        request.userConfirm = !!flags.isUserConfirm;
        request.ignoreCrewTypeWarning = !!flags.isIgnoreCrewTypeWarning;
        request.ignoreConflicts = !!flags.isIgnoreConflicts;
        request.ignoreExpiries = !!flags.isIgnoreExpiries;
        request.expiryUpdatable = !!flags.isExpiryUpdatable;

        RemoteService.assignTrainerTrainee(request).then(
          function (response) {
            var adapted = CrewingAdaptor.assignTrainingAdaptor(response);
            CrewingHelper.assignTrainingActionList(request, adapted, flags, performOneAssignment, assignSuccessCallBack, abortAssignment);
          },
          function (error) {
            abortAssignment();
            MessageService.error(error);
          }
        );
      }

    // Perform assignments in batch
    function performAssignment(requestList) {

      var flags = self.getCrewAssignToTrainingFlagsForAllSelect();
      var isArray = Array.isArray(requestList);
      var requestListUpdated = isArray ? requestList : [requestList];

      requestListUpdated.forEach(function (request, index) {

          request.continueIllegal = false;
          request.userConfirm = true;
          request.ignoreCrewTypeWarning = true;
          request.ignoreConflicts = true;
          request.ignoreExpiries = true;
          request.expiryUpdatable = true;
          request.ignoreRequest = true;

      });

      RemoteService.assignTrainerTraineeBulk(requestListUpdated).then(
        function (responseList) {
          for (var i = 0; i < responseList.length; i++) {
            var adapted = CrewingAdaptor.assignTrainingAdaptor(responseList[i]);
            CrewingHelper.assignTrainingActionList(
              requestListUpdated[i],
              adapted,
              flags,
              performAssignment,
              assignSuccessCallBack,
              abortAssignment
            );
          }

        },
        function (error) {
          abortAssignment();
          MessageService.error(error);
        }
      );
    }
  };
    }
}());
